import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import * as Models from 'app/core/models';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import { ModalService } from 'app/modal/modal.service';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmationModal.component.html',
    styleUrls: ['./confirmationModal.component.scss']
})
export class ConfirmationModalComponent implements OnInit, Models.ModalComponent {

    @ViewChild('modalConfirmation') public contentModal: any;
    title = '';
    message1 = '';
    message2 = '';
    isLoading = false;

    constructor(private authenticationService: AuthenticationService,
        private userService: UserService,
        private router: Router,
        private lookupService: LookupService,
        private modalService: ModalService) {
    }

    ngOnInit() {
        this.isLoading = false;
    }

    openConfirmationModal() {
        this.contentModal.show();
    }

    closeConfirmationModal() {
        this.contentModal.hide();
    }

    closeModal() {
        this.closeConfirmationModal();
    }

    openModal(data: any[]): void {
        this.title = data[0];
        this.message1 = data[1];
        this.message2 = data[2];

        this.isLoading = false;
        this.openConfirmationModal();
    }

    confirm(): void {
        this.isLoading = true;
        this.modalService.returnEvent(true);
    }

    cancel(): void {
        this.modalService.returnEvent(false);
    }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/confirmationModal/confirmationModal.component.ts